import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
//import jobmixin from '@/helpers/Mixins/JobMixin.js';
export default {
    methods: {
        async toggleAssetTypesEnabled() {
            var meta = {
                clientApiMethod: 'toggleAssetTypesEnabled',
                input: {},
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.setting.setting") })
            }
            var response = await client().post(store.state.apiRouteRoot + "AssetType/ToggleFeature", null, { meta: meta })
            return response?.data;
        },
        async getAllAssetTypes() {
            var meta = { clientApiMethod: 'getAllAssetTypes', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "AssetType", { meta: meta })
            return response?.data;
        },
        async getAssetTypeListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getAssetTypeListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "AssetType/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getAssetType(AssetTypeId) {
            var meta = { clientApiMethod: 'getAssetType', input: { AssetTypeId: AssetTypeId } }
            var response = await client().get(store.state.apiRouteRoot + "AssetType/" + AssetTypeId, { meta: meta })
            return response?.data;
        },
        async createAssetType(newAssetType) {
            var meta = {
                clientApiMethod: 'createAssetType',
                input: { newAssetType },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().put(store.state.apiRouteRoot + 'AssetType', newAssetType, { meta: meta })
            return response?.data;
        },
        async changeAssetType(updatedAssetType) {
            var meta = {
                clientApiMethod: 'changeAssetType',
                input: { updatedAssetType },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'AssetType', updatedAssetType, { meta: meta })
            return response?.data;
        },
        async deleteAssetType(AssetTypeId) {
            var meta = {
                clientApiMethod: 'deleteAssetType',
                input: { AssetTypeId: AssetTypeId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.machine.asset_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "AssetType/" + AssetTypeId, { meta: meta })
            return response?.data;
        },
    }
}